import { render, staticRenderFns } from "./PartnersSection.vue?vue&type=template&id=4eaecd3d&scoped=true&"
import script from "./PartnersSection.vue?vue&type=script&lang=js&"
export * from "./PartnersSection.vue?vue&type=script&lang=js&"
import style0 from "./PartnersSection.vue?vue&type=style&index=0&id=4eaecd3d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eaecd3d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardTitle,VCol,VImg,VRow})
